import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { IoClose } from "react-icons/io5";

const EditorDialog = ({ open, onClose, title, children, maxWidth = "sm" }) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth={maxWidth}
    dir="rtl"
    PaperProps={{ className: "max-h-[calc(100dvh-2rem)] rounded-2xl" }}
  >
    <DialogTitle className="flex items-center justify-between gap-3 border-b border-gray-100 font-bold">
      <span>{title}</span>
      <IconButton onClick={onClose} aria-label="بستن پنجره" size="small">
        <IoClose />
      </IconButton>
    </DialogTitle>
    <DialogContent className="overflow-y-auto pt-5">{children}</DialogContent>
  </Dialog>
);

export default EditorDialog;
